import React, { useState } from "react";
import { Button } from "../../components/ButtonStyle";
import Navbar from "../../components/Navbar/Navbar";
import Sidebar from "../../components/Sidebar/Sidebar";
import {
  BackButton,
  FormContainer,
  FormGroup,
  FormHeading,
  FormSubmit,
  FormWrapper,
  Input,
  Label,
  Message,
} from "./QuotesStyle";

const Quotes = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <FormContainer>
        <FormHeading>
          Tell me more about your requirements so we can be on the same page!
        </FormHeading>
        <FormWrapper>
          <FormGroup>
            <Label htmlFor="first__name">First Name:</Label>
            <Input
              id="first__name"
              type="fname"
              placeholder="enter your first name"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="last__name">Last Name:</Label>
            <Input
              id="last__name"
              type="lname"
              placeholder="enter your last name"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="email__id">E-Mail:</Label>
            <Input
              id="email__id"
              type="email"
              placeholder="enter a valid email id"
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="requirements">Requirements:</Label>
            <Input
              id="requirements"
              className="requirements"
              placeholder="enter your requirements for the website"
            />
          </FormGroup>
          <FormSubmit>Submit</FormSubmit>
        </FormWrapper>

        <BackButton to="/">Go Back!</BackButton>
      </FormContainer>
    </>
  );
};

export default Quotes;
